import { combineReducers } from "redux";
import {
  FETCH_COUNTRIES_REQUEST,
  UPDATE_COUNTRY_STATUS_REQUEST,
  UPDATE_COUNTRY_WEIGHT_REQUEST,
} from "./constants";
import { arrayToObject } from "../../utils/arrayToObject";
import { getFailureActionType, getSuccessActionType } from "../utils";
import { Action, CountriesState } from "./types";

function items(state: CountriesState = {}, action: Action): CountriesState {
  switch (action.type) {
    case getSuccessActionType(FETCH_COUNTRIES_REQUEST):
      return arrayToObject(action.payload);

    case UPDATE_COUNTRY_STATUS_REQUEST:
    case UPDATE_COUNTRY_WEIGHT_REQUEST:
      return { ...state, [action.data.countryId]: { ...state[action.data.countryId], isFetching: true } };

    case getSuccessActionType(UPDATE_COUNTRY_STATUS_REQUEST):
    case getSuccessActionType(UPDATE_COUNTRY_WEIGHT_REQUEST):
      return { ...state, [action.data.countryId]: { isFetching: false, ...action.payload } };

    case getFailureActionType(UPDATE_COUNTRY_STATUS_REQUEST):
    case getFailureActionType(UPDATE_COUNTRY_WEIGHT_REQUEST):
      return { ...state, [action.data.countryId]: { ...state[action.data.countryId], isFetching: false } };

    default:
      return state;
  }
}

function isFetching(state: boolean = false, action: Action): boolean {
  switch (action.type) {
    case FETCH_COUNTRIES_REQUEST:
      return true;

    case getSuccessActionType(FETCH_COUNTRIES_REQUEST):
    case getFailureActionType(FETCH_COUNTRIES_REQUEST):
      return false;

    default:
      return state;
  }
}

export const countries = combineReducers({ items, isFetching });
